import React, {useEffect, useState} from 'react';
import axios from 'axios';
import InfoCards from '../components/HomeInfoCard';
import HomeToOtherPage from '../components/HomeToOtherPage';

export default function HomePage({setPage}){
    const [data, setData] = useState({}); //data is for saving data from flask(title, url...)
    
    useEffect(()=>{
        axios.get("/api/homepage") //<->methods["GET"]
        .then(res=>setData(res.data)); //setData->get res.data than save to state
    },[]); //[]-> only execute once (like the default state here)

    return(
        <div style={{backgroundColor: '#f9f7f2',}}>
            <div style={{ textAlign: 'center', padding: '40px', 
                            display:'flex', gap:'30px', alignItems:'center'}}>
                {/* LOGO */}
                {data.logo_url &&(<img src={data.logo_url} alt="logo" style={{
                            width:'240px', marginBottom:'20px', marginLeft:'50px',
                            filter: 'contrast(90%) brightness(95%)'
                        }}/>)}
                
                {/* TITLE */}
                <h1 style={{ color: "#209eb8", fontSize: '4rem', 
                            fontFamily: `"Microsoft JhengHei", "Noto Sans TC", sans-serif`}}>
                    {data.title}</h1>
            </div>

            {/* INFOCARDS */}
            {/* <div>
                <InfoCards></InfoCards>
            </div> */}
                
            {/* SWITCH TO OTHER PAGE */}
            <div>
                <HomeToOtherPage setPage={setPage}></HomeToOtherPage>
            </div>
            
        </div>
    )

}
